import moment from 'moment-timezone';
import {COUNTRY} from 'front-onceforall-core/dist/utils/country';
import {
  GROUP_NUMBER_CODE,
  VAT_IDENTIFICATION_NUMBER_CODE
} from 'front-onceforall-core/dist/utils/organisations';
import {findOrganisation} from '../organisation/FakeOrganisationService';
import {ACTRADIS_MASTER_PLATFORM, status} from '../../utils/constant';

let relationshipsInDb = [
  {
    relationshipId: 10,
    organisationSource: {
      fullName: 'random orga name'
    },
    subcontractor: {
      enabled: true,
      organisationId: 2,
      country: COUNTRY.GERMANY,
      fullName: 'D&S',
      registrationNumber: '12345679',
      interoperatedOrganisation: {
        country: COUNTRY.FRANCE,
        enabled: true,
        masterPlatform: ACTRADIS_MASTER_PLATFORM
      },
      address: {
        addressLine: 'BrahmStrasse 10',
        postCode: '69300',
        city: 'Lindau'
      },
      identificationNumbers: {
        [GROUP_NUMBER_CODE]: '813348513',
        [VAT_IDENTIFICATION_NUMBER_CODE]: '813349993'
      },
      depositor: false,
      status: status.ACCEPTED,
      creationDate: '2018-10-04T10:15:30.00Z'
    },
    client: {
      enabled: true,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '12345678',
      address: {
        addressLine: "50, rue de l'oie",
        postCode: '69300',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-03-01T10:15:30.00Z',
      identificationNumbers: {}
    },
    status: status.ACCEPTED,
    emitterOrganisationId: 1,
    resendable: false,
    favorite: false,
    hasInterventionInProject: true
  },
  {
    relationshipId: 11,
    organisationSource: {
      fullName: 'random orga name'
    },
    subcontractor: {
      enabled: true,
      organisationId: 3,
      country: COUNTRY.GERMANY,
      fullName: 'ILG',
      registrationNumber: '50320789',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-08-11T10:15:30.00Z',
      identificationNumbers: {}
    },
    client: {
      enabled: true,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '12345678',
      address: {
        addressLine: "50, rue de l'oie",
        postCode: '69300',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-03-01T10:15:30.00Z',
      identificationNumbers: {}
    },
    status: status.ACCEPTED,
    emitterOrganisationId: 1,
    resendable: false,
    favorite: false
  },
  {
    relationshipId: 12,
    organisationSource: {
      fullName: 'random orga name'
    },
    subcontractor: {
      enabled: true,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '12345678',
      address: {
        addressLine: "50, rue de l'oie",
        postCode: '69300',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-03-01T10:15:30.00Z',
      identificationNumbers: {}
    },
    client: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-03-03T10:15:30.00Z',
      identificationNumbers: {}
    },
    status: status.ACCEPTED,
    emitterOrganisationId: 10,
    resendable: false,
    favorite: false
  },
  {
    relationshipId: 13,
    organisationSource: {
      fullName: 'random orga name'
    },
    subcontractor: {
      enabled: true,
      organisationId: 3,
      country: COUNTRY.GERMANY,
      fullName: 'ILG',
      registrationNumber: '50320789',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-08-11T10:15:30.00Z',
      identificationNumbers: {}
    },
    client: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-03-03T10:15:30.00Z',
      identificationNumbers: {}
    },
    status: status.ACCEPTED,
    emitterOrganisationId: 10,
    resendable: false,
    favorite: false
  },
  {
    relationshipId: 14,
    client: {
      enabled: true,
      organisationId: 4,
      country: COUNTRY.GERMANY,
      fullName: 'MAITRISE ASSISTANCE TECHNIQUE ETUDE CONCEPTION M.A.T.E.C.',
      registrationNumber: '34567812',
      address: {
        addressLine: 'BrahmStrasse 9',
        postCode: '69300',
        city: 'Lindau'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-05-07T10:15:30.00Z',
      identificationNumbers: {}
    },
    organisationSource: {
      fullName: 'random orga name'
    },
    subcontractor: {
      enabled: true,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '12345678',
      address: {
        addressLine: "50, rue de l'oie",
        postCode: '69300',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-03-01T10:15:30.00Z',
      identificationNumbers: {}
    },
    status: status.ACCEPTED,
    emitterOrganisationId: 1,
    resendable: false,
    favorite: true,
    hasInterventionInProject: true
  },
  {
    relationshipId: 15,
    organisationSource: {
      fullName: 'random orga name'
    },
    subcontractor: {
      enabled: true,
      organisationId: 162,
      country: COUNTRY.GERMANY,
      fullName: 'S&D',
      registrationNumber: '97654321',
      address: {
        addressLine: 'BrahmStrasse 01',
        postCode: '63900',
        city: 'Olm'
      },
      interoperatedOrganisation: {
        country: COUNTRY.FRANCE,
        enabled: true,
        masterPlatform: ACTRADIS_MASTER_PLATFORM
      },
      identificationNumbers: {
        [GROUP_NUMBER_CODE]: '813348513',
        [VAT_IDENTIFICATION_NUMBER_CODE]: '813349993'
      },
      depositor: false,
      status: status.ACCEPTED,
      creationDate: '2018-10-04T10:15:30.00Z'
    },
    client: {
      enabled: true,
      organisationId: 161,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 161',
      registrationNumber: '87654321',
      address: {
        addressLine: "05, rue de l'oie",
        postCode: '63900',
        city: 'Clermont-Ferrand'
      },
      depositor: true,
      status: status.ACCEPTED,
      identificationNumbers: {}
    },
    status: status.PENDING,
    resendable: true,
    creationDate: '2018-03-01T10:15:30.00Z',
    favorite: false
  },
  {
    relationshipId: 16,
    client: {
      enabled: true,
      organisationId: 3,
      country: COUNTRY.GERMANY,
      fullName: 'ILG',
      registrationNumber: '50320789',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      identificationNumbers: {}
    },
    organisationSource: {
      fullName: 'random orga name'
    },
    subcontractor: {
      enabled: true,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '12345678',
      address: {
        addressLine: "50, rue de l'oie",
        postCode: '69300',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      identificationNumbers: {}
    },
    status: status.PENDING,
    resendable: false,
    creationDate: '2018-08-11T10:15:30.00Z',
    favorite: false
  },
  {
    relationshipId: 17,
    organisationSource: {
      fullName: 'random orga name'
    },
    subcontractor: {
      enabled: true,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '12345678',
      address: {
        addressLine: "50, rue de l'oie",
        postCode: '69300',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-03-01T10:15:30.00Z',
      identificationNumbers: {}
    },
    client: {
      enabled: true,
      organisationId: 10,
      country: COUNTRY.GERMANY,
      fullName: 'ALG',
      registrationNumber: '52773773',
      address: {
        addressLine: '20, boulevard eugène deruelle',
        postCode: '69003',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-03-03T10:15:30.00Z',
      identificationNumbers: {}
    },
    status: status.PENDING,
    resendable: true,
    favorite: false
  },
  {
    relationshipId: 18,
    organisationSource: {
      fullName: 'random orga name'
    },
    subcontractor: {
      enabled: true,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '12345678',
      address: {
        addressLine: "50, rue de l'oie",
        postCode: '69300',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-03-01T10:15:30.00Z',
      identificationNumbers: {}
    },
    client: {
      enabled: true,
      organisationId: 5,
      country: COUNTRY.FRANCE,
      fullName: 'COLAS',
      registrationNumber: '81334851300017',
      address: {
        addressLine: '89 rue du coq',
        postCode: '45600',
        city: 'Sully sur Loire'
      },
      identificationNumbers: {
        [GROUP_NUMBER_CODE]: '813348513'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-05-07T10:15:30.00Z'
    },
    status: status.PENDING,
    emitterOrganisationId: 10,
    resendable: true,
    favorite: false
  },
  {
    relationshipId: 19,
    client: {
      enabled: false,
      organisationId: 7,
      country: COUNTRY.FRANCE,
      fullName: 'Papier Craft',
      registrationNumber: '84230331500019',
      businessLine: 'CLEANING',
      address: {
        addressLine: '119 rue Francis de pressense',
        postCode: '69100',
        city: 'Villeurbanne'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-05-07T10:15:30.00Z',
      identificationNumbers: {}
    },
    organisationSource: {
      fullName: 'random orga name'
    },
    subcontractor: {
      enabled: true,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '12345678',
      address: {
        addressLine: "50, rue de l'oie",
        postCode: '69300',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-03-01T10:15:30.00Z',
      identificationNumbers: {}
    },
    status: status.ACCEPTED,
    emitterOrganisationId: 1,
    resendable: false,
    favorite: false
  },
  {
    relationshipId: 20,
    organisationSource: {
      fullName: 'random orga name'
    },
    subcontractor: {
      enabled: false,
      organisationId: 7,
      country: COUNTRY.FRANCE,
      fullName: 'Papier Craft',
      registrationNumber: '84230331500019',
      businessLine: 'CLEANING',
      address: {
        addressLine: '119 rue Francis de pressense',
        postCode: '69100',
        city: 'Villeurbanne'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-05-07T10:15:30.00Z',
      identificationNumbers: {}
    },
    client: {
      enabled: true,
      organisationId: 1,
      country: COUNTRY.GERMANY,
      fullName: 'Organisation 1',
      registrationNumber: '12345678',
      address: {
        addressLine: "50, rue de l'oie",
        postCode: '69300',
        city: 'Lyon'
      },
      depositor: true,
      status: status.ACCEPTED,
      creationDate: '2018-03-01T10:15:30.00Z',
      identificationNumbers: {}
    },
    status: status.ACCEPTED,
    emitterOrganisationId: 1,
    resendable: false,
    favorite: true
  }
];

let favoriteRelationshipsInDB = [
  {
    id: 600,
    relationshipId: 22,
    userId: 'some-uuid'
  },
  {
    id: 601,
    relationshipId: 14,
    userId: 'some-uuid'
  }
];

export const findRelation = (clientId, subcontractorId) => relationshipsInDb.find(
  relationship => relationship.client.organisationId === clientId &&
      relationship.subcontractor.organisationId === subcontractorId
);

export const findSubcontractorRelationships = clientId => relationshipsInDb.filter(
  relationship => relationship.client.organisationId === clientId
);

export const findClientRelationships = subcontractorId => relationshipsInDb.filter(
  relationship => relationship.subcontractor.organisationId === subcontractorId
);

export const findReceivedRelationships = organisationId => relationshipsInDb.filter(
  relationship => relationship.emitterOrganisationId !== organisationId &&
      (relationship.clientId === organisationId ||
        relationship.subcontractorId === organisationId) &&
      relationship.status === status.PENDING
);

export const findSentRelationships = organisationId => relationshipsInDb.filter(
  relationship => relationship.emitterOrganisationId === organisationId &&
      relationship.status === status.PENDING
);

export const searchForClientOrSubcontractor = (subcontractorId, clientId) => {
  const response = findRelation(clientId, subcontractorId);
  if (response) {
    return Promise.resolve([response]);
  }

  return Promise.resolve();
};

export default class FakeRelationshipService {
  searchSubcontractorsByQuery(
    clientId,
    selectedStatus,
    userId,
    query = '',
    page = 0,
    pageSize = 10
  ) {
    return new Promise(resolve => {
      const relationships = findSubcontractorRelationships(clientId);
      const matchingRelationships = relationships
        .filter(relationship => (relationship.status === selectedStatus) &&
         relationship.organisationSource.fullName.toLowerCase().startsWith(query.toLowerCase()))
        .sort((rel1, rel2) => rel2.favorite - rel1.favorite);
      resolve({
        relationships: matchingRelationships.slice(
          page * pageSize,
          (page + 1) * pageSize
        ),
        totalCount: matchingRelationships.length
      });
    });
  }

  searchClientsByQuery(
    subcontractorId,
    selectedStatus,
    userId,
    query = '',
    page = 0,
    pageSize = 10
  ) {
    return new Promise(resolve => {
      const relationships = findClientRelationships(subcontractorId);
      const matchingRelationships = relationships
        .filter(
          relationship => relationship.status === selectedStatus &&
            relationship.organisationSource.fullName
              .toLowerCase()
              .startsWith(query.toLowerCase())
        )
        .sort((rel1, rel2) => rel2.favorite - rel1.favorite);
      resolve({
        relationships: matchingRelationships.slice(
          page * pageSize,
          (page + 1) * pageSize
        ),
        totalCount: matchingRelationships.length
      });
    });
  }

  addSubcontractors(subcontractorIds, clientId) {
    const client = findOrganisation(clientId);
    const relationships = subcontractorIds.map(subcontractorId => {
      const subcontractor = findOrganisation(subcontractorId);
      return {
        subcontractor,
        client,
        status: status.ACCEPTED,
        emitterOrganisationId: clientId
      };
    });
    relationshipsInDb.push(...relationships);
    return Promise.resolve(relationships);
  }

  addClients(clientIds, subcontractorId) {
    const subcontractor = findOrganisation(subcontractorId);
    const relationships = clientIds.map(clientId => {
      const client = findOrganisation(clientId);
      return {
        client,
        subcontractor,
        status: status.ACCEPTED,
        emitterOrganisationId: subcontractorId
      };
    });
    relationshipsInDb.push(...relationships);
    return Promise.resolve(relationships);
  }

  searchForSubcontractor(subcontractorId, clientId) {
    return searchForClientOrSubcontractor(subcontractorId, clientId);
  }

  searchForClient(clientId, subcontractorId) {
    return searchForClientOrSubcontractor(subcontractorId, clientId);
  }

  getPendingSentInvitations(organisationId, page, size) {
    const relationships = findSentRelationships(organisationId);
    const matchingRelationships = relationships.map(relationship => ({
      ...relationship,
      relationshipId: relationship.relationshipId,
      resendable: relationship.resendable
    }));

    return Promise.resolve({
      relationships: matchingRelationships.slice(
        page * size,
        (page + 1) * size
      ),
      totalCount: matchingRelationships.length
    });
  }

  accept(relationshipId) {
    relationshipsInDb = relationshipsInDb.filter(
      relationship => relationship.relationshipId !== relationshipId
    );
    return new Promise(resolve => setTimeout(() => resolve('success'), 0));
  }

  reject(relationshipId) {
    relationshipsInDb = relationshipsInDb.filter(
      relationship => relationship.relationshipId !== relationshipId
    );
    return new Promise(resolve => setTimeout(() => resolve('success'), 0));
  }

  resendInvitation(relationshipId) {
    const sentInvitation = relationshipsInDb.find(
      relationship => relationship.relationshipId === relationshipId
    );
    sentInvitation.resendable = false;
    sentInvitation.creationDate = moment.now();
    return Promise.resolve([sentInvitation]);
  }

  getRelationship(relationshipId) {
    const relationship = relationshipsInDb.find(
      relationshipItem => relationshipItem.relationshipId === Number(relationshipId)
    );
    return Promise.resolve(relationship);
  }

  deleteRelationship(relationshipId) {
    relationshipsInDb = relationshipsInDb.filter(
      relationship => relationship.relationshipId !== relationshipId
    );
    return new Promise(resolve => setTimeout(() => resolve('success'), 0));
  }

  isFavoriteRelationship(subcontractorId, clientId, userId) {
    const relationship = findRelation(clientId, subcontractorId);
    if (relationship) {
      const favoriteRelationship = favoriteRelationshipsInDB.find(
        relationshipItem => relationshipItem.relationshipId === relationship.relationshipId &&
          relationshipItem.userId === userId
      );
      if (favoriteRelationship) {
        return new Promise(resolve => {
          setTimeout(() => resolve(true), 0);
        });
      }

      return new Promise(resolve => {
        setTimeout(() => resolve(false), 0);
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => reject(), 0);
    });
  }

  switchFavoriteRelationshipState(
    subcontractorId,
    clientId,
    userId,
    isFavorite
  ) {
    const relationship = findRelation(clientId, subcontractorId);
    if (relationship) {
      if (isFavorite) {
        relationship.favorite = true;
        favoriteRelationshipsInDB.push({
          relationshipId: relationship.relationshipId,
          userId
        });
        return new Promise(resolve => {
          setTimeout(() => resolve(), 0);
        });
      }

      relationship.favorite = false;
      favoriteRelationshipsInDB = favoriteRelationshipsInDB.filter(
        favoriteRelationship => favoriteRelationship.relationshipId !== relationship.relationshipId &&
          favoriteRelationship.userId !== userId
      );
      return new Promise(resolve => {
        setTimeout(() => resolve(), 0);
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => reject(), 0);
    });
  }

  getSubcontractorsCountByUser() {
    return new Promise(resolve => {
      setTimeout(() => resolve(4), 0);
    });
  }

  searchSubcontractorsByUser() {
    return new Promise(resolve => {
      setTimeout(
        () => resolve({
          subcontractors: [findOrganisation(3), findOrganisation(5)],
          totalCount: 2
        }),
        500
      );
    });
  }

  getSubcontractorClientIds() {
    return new Promise(resolve => {
      setTimeout(() => resolve([1]), 0);
    });
  }

  cancelPendingRelationship(relationshipId) {
    this.deleteRelationship(relationshipId);
  }
}
